<app-frame
  title="Loading..."
  [showBack]="false"
>

</app-frame>
